module.exports = __webpack_public_path__ + "templates/cart-address.html";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/cart/templates/cart-address.html
// module id = hykR
// module chunks = 1